import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { ResponsiveRowProps } from './responsiveRow.props'

export const ResponsiveRowType = ComponentTypeFactory.create<ResponsiveRowProps>(
  'ResponsiveRow',
  {
    mobileCols: FieldTypeFactory.number({
      required: true,
      label: 'Number of Columns on Mobile (1-5)',
    }),
    tabletCols: FieldTypeFactory.number({
      required: true,
      label: 'Number of Columns on Tablet (1-5)',
    }),
    desktopCols: FieldTypeFactory.number({
      required: true,
      label: 'Number of Columns on Desktop (1-5)',
    }),
  }
)
